/* eslint-disable */
<template>
  <div class="hours-booked">
    <AdminNavigation ref="navigation" indexProps="6" />
    <div class="top-panel no-sub-title">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Number of Hours of Appointments Booked ({{ totalHours }})</h1></div>
      </div>
    </div>
    <div class="panel no-sub-title">
      <AdminReportsMenu indexProps="3" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <v-md-date-range-picker @change="setDates" class="mr-3"></v-md-date-range-picker>
            <download-csv :data="getCalendarData()" :name="getFileName()">
              <v-btn dark>CSV <img src="@/assets/images/download_light_icon.svg" class="ml-3" /></v-btn>
            </download-csv>
            <!-- <v-btn @click="getCalendarData()">test</v-btn> -->
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <div>
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 20%" class="long-text">Client Name</th>
                    <th style="width: 20%" class="long-text">Branch Name</th>
                    <th style="width: 20%" class="long-text">Month</th>
                    <th style="width: 20%" class="long-text">
                      Number of Bookings
                    </th>
                    <th style="width: 20%" class="long-text">
                      Number of Hours
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div :class="hoursBooked.length > 5 ? 'content-scroll-y' : ''">
              <table class="table">
                <tbody>
                <tr v-for="(hour, key) in allHoursBooked" :key="key">
                  <td style="width: 20%">{{hour.clientName}}</td>
                  <td style="width: 20%">&nbsp;{{hour.branchName}}</td>
                  <td style="width: 20%">{{ hour.groupingDate }}</td>
                  <td style="width: 20%">{{ hour.numberOfBookings }}</td>
                  <td style="width: 20%">{{ hour.bookedHours }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities";
import AdminNavigation from "@/components/AdminNavigation";
import AdminAvailabilityMenu from "@/components/AdminAvailabilityMenu";
import Header from "@/components/Header";
import AdminReportsMenu from "@/components/AdminReportsMenu";

export default {
  name: "AdminHoursBookedByClientPerMonth",
  components: {
    AdminNavigation,
    AdminAvailabilityMenu,
    Header,
    AdminReportsMenu,
  },
  data() {
    return {
      hasError: false,
      successMessage: "",
      errorMessage: "Please correct the errors shown above and try again.",
      hoursBooked: {},
      limit: 20,
      allHoursBooked: {},
      errorMessage: "",
      successMessage: "",
      totalHours: 0,
    };
  },
  methods: {
    async loadData(startDate = "", endDate = "") {
      await this.$store.dispatch("loading/setLoadComponent", true);
      this.totalHours = 0;
      if (startDate == "" || startDate == endDate)
        this.allHoursBooked = await utilities.getReportHoursBookedByClient(
          window.moment().format("YYYY-MM-DD"),
            window.moment().add(1, "y").format("YYYY-MM-DD")
        );
      else
        this.allHoursBooked = await utilities.getReportHoursBookedByClient(
          startDate,
          endDate
        );
      this.allHoursBooked.map((x) => {
        this.totalHours += parseFloat(x.bookedHours)
      })
      await this.$store.dispatch("loading/setLoadComponent", false);
    },

    getFileName() {
      return "Hours_booked_" + window.moment().format("YYYYMMDDHHmm") + ".csv";
    },

    getCalendarData() {
      var calendarData = [];
      for (var key in this.hoursBooked) {
        if (this.hoursBooked.hasOwnProperty(key)) {
          calendarData.push({
            "Client Name": key,
            "Branch Name": this.hoursBooked[key].branchName,
            Month: "",
            "Number of Bookings": this.hoursBooked[key].totalBookings,
            "Number of Hours": parseFloat(
              this.hoursBooked[key].totalHours
            ).toFixed(2),
          });
          for (var i = 0; i < this.hoursBooked[key].details.length; i++) {
            calendarData.push({
              "Client Name": "",
              "Branch Name": "",
              Month: this.hoursBooked[key].details[i].month,
              "Number of Bookings": this.hoursBooked[key].details[i]
                .numberOfBookings,
              "Number of Hours": parseFloat(
                this.hoursBooked[key].details[i].numberOfHours
              ).toFixed(2),
            });
          }
        }
      }
      return calendarData;
    },

    async setDates(values) {
      this.$store.dispatch("loading/setLoadComponent", true);
      var commencingDate = values[0];
      var endingDate = values[1];
      await this.loadData(
        commencingDate.format("YYYY-MM-DD"),
        endingDate.format("YYYY-MM-DD")
      );
      this.$store.dispatch("loading/setLoadComponent", false);
    },
  },
  async beforeMount() {
    await this.$store.dispatch("loading/setLoadComponent", true);
    await this.loadData();
    await this.$store.dispatch("loading/setLoadComponent", false);
  },
  mounted() {},
};
</script>
